var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigiseqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 806 223",
    width: 806,
    height: 223,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "digiseq-logo-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #ff6400 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m328.5 87.9q1 5 1 13.6v21.6q0 8.4-1 13.4-1.1 5-2.9 8.9-1.8 4.1-4.8 7.8-3.1 3.7-7.5 6.5-4.4 2.8-10.3 4.4-5.9 1.5-13.3 1.5h-39.4c-0.7 0-1.3-0.5-1.3-1.2v-104.9c0-0.7 0.6-1.3 1.3-1.3h37q7.9 0 14.1 1.7 6.3 1.7 11 4.5 4.8 2.7 8 6.4 3.3 3.7 5.2 8 1.8 4 2.9 9.1zm-19.2 12.9q0-7.4-1.6-12.5-1.5-5-4.3-8-2.9-3-7-4.4-4.1-1.4-9.5-1.4h-18.1v74.8h18.1q5.5 0 9.7-1.2 4.1-1.3 6.9-4.3 2.9-3.1 4.3-8.1 1.5-5.1 1.5-12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m472.6 89.6q0 0.2 0 0.3 0 0 0 0.1v2c0 0.7-0.6 1.2-1.3 1.2h-17.4c-0.7 0-1.3-0.5-1.3-1.2v-2q0-0.1 0-0.1 0-0.2 0-0.4-0.6-8.4-5.7-12.1-5.1-3.7-15.3-3.7-5.8 0-10 1.2-4.1 1.3-6.7 4.4-2.6 3.1-3.9 8.3-1.3 5.1-1.3 13v24.8q0 15 5.4 21 5.3 6.1 16.5 6.1 10.5 0 15.9-5.1 5.4-5 5.4-17.1v-2.7h-15.5c-0.7 0-1.3-0.5-1.3-1.2v-3.2q0-0.2 0-0.4v-6.5q0-0.3 0-0.5v-3.1c0-0.6 0.6-1.2 1.3-1.2h16.5 0.3 17.1c0.7 0 1.3 0.6 1.3 1.2v2.9q0 0 0 0 0 0.1 0 0.2v16.7q0 7.3-2.5 13.7-2.4 6.4-7.5 11.3-5.1 4.9-12.9 7.7-7.7 2.8-18.2 2.8-15.4 0-24.4-5.2-8.9-5.3-13.5-14.9-2.1-4.3-2.9-9.5-0.8-5.3-0.8-13.9v-21.6q0-15.2 3.7-23.3 4.6-10.7 14.8-16.1 10.2-5.5 24.5-5.5 8.1 0 15.3 1.8 7.2 1.9 12.6 5.7 5.4 3.9 8.6 9.9 3.2 6 3.2 14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m603.2 118.4q6 7.3 6 17.8v1.9q0 14.4-10 22.1-10 7.8-28.3 7.8-21.6 0-31.6-9.3-3.9-3.9-6.1-8.6c-1.3-2.8-2-5.8-2.1-8.9q0-0.1 0-0.3v-3.5c0-0.7 0.5-1.2 1.3-1.2h16.2c0.8 0 1.4 0.5 1.5 1.2l0.3 2.3q0 0.1 0 0.2 1.5 6.4 6.2 9.5 4.8 3.2 13.5 3.2 10 0 14.5-3.3 4.4-3.3 4.4-10.9 0-5.9-3.6-9.7-3.7-3.7-11.8-6.1l-16.8-4.9q-11.8-3.4-18-10.5-6.3-7.1-6.3-16.8v-1.4q0-14.7 10.1-22.9 10.1-8.1 28.6-8.1 20 0 29.7 9.9 6.4 6.8 6.6 16.3 0.1 0 0.1 0.1v0.7q0 0 0 0.1 0 0 0 0v2.8c0 0.6-0.6 1.1-1.3 1.1h-3.8-9.1-3.6c-0.7 0-1.4-0.5-1.4-1.1l-0.2-2.6q-1.5-12.1-18.6-12.1-17.4 0-17.4 14.7 0 2.9 0.8 5.1 0.8 2.3 2.7 4 1.9 1.7 5 3.1 3.1 1.4 7.7 2.7l16.8 4.9q12.1 3.4 18 10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m787.6 150.3h11.6c0.7 0 1.3 0.5 1.3 1.1v13c0 0.7-0.6 1.2-1.3 1.2h-41.7q-0.1 0-0.1 0-20.1-0.4-29.9-10.6-10.2-10.7-10.2-30.5v-21.6q0-7.6 0.9-13.2 0.8-5.5 2.8-10.1 4.6-10.7 14.2-16.1 9.6-5.5 23.7-5.5 14.1 0 23.7 5.1 9.6 5.1 14.2 15 2.1 4.3 2.9 9.6 0.8 5.3 0.8 13.8v22.7q0 19.3-12.9 26.1zm-28.7-0.5q11.7 0 16.7-6 5-6 5-19.6v-23.6q0-14.2-5-20.5-5.1-6.3-16.7-6.3-11.8 0-16.8 6.3-5 6.3-5 20.5v23.6q0 13.6 5 19.6 5 6 16.8 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m513.7 59.2v3.2 3.9 91.1 3.9 3.1c0 0.7-0.6 1.2-1.3 1.2h-3.9-9.4-3.9c-0.7 0-1.3-0.5-1.3-1.2v-3.1-3.9-91.1-3.9-3.2c0-0.7 0.6-1.2 1.3-1.2h3.9 9.4 3.9c0.7 0 1.3 0.5 1.3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m699.8 150.5v3.6 6.7 3.6c0 0.7-0.6 1.2-1.3 1.2h-3.4-13.8-34.1-13.3-3.9c-0.7 0-1.3-0.5-1.3-1.2v-3.1-3.9-91.1-3.9-3.2c0-0.7 0.6-1.2 1.3-1.2h3.9 13.3 33.5 13.7 3.5c0.7 0 1.3 0.5 1.3 1.2v13.9c0 0.7-0.6 1.2-1.3 1.2h-3.5-13.7-32.2v27.8h27.9 13.8 3.4c0.7 0 1.3 0.6 1.3 1.3v13.9c0 0.6-0.6 1.2-1.3 1.2h-3.4-13.8-27.9v30.8h32.8 13.8 3.4c0.7 0 1.3 0.6 1.3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m371 59.5v3.1 3.9 90.9 3.9 3.1c0 0.7-0.6 1.2-1.3 1.2h-3.9-9.4-3.9c-0.7 0-1.3-0.5-1.3-1.2v-3.1-3.9-90.9-3.9-3.1c0-0.7 0.6-1.3 1.3-1.3h3.9 9.4 3.9c0.7 0 1.3 0.6 1.3 1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m116.8 4.4v53.9h-53.9v53.9c-0.2 0 0.2 0 0 0-29.7 0-53.9-24.1-53.9-53.9 0-29.8 24.2-53.9 53.9-53.9 0.2 0 0.2 0 0.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m116.8 112.2v-53.9c44.6 0 80.8 36.2 80.8 80.9 0 44.6-36.2 80.8-80.8 80.8h-53.9v-107.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiseqLogo);
export default __webpack_public_path__ + "static/media/digiseq-logo.4effe06c38579826cbdddc4a470f2f9e.svg";
export { ForwardRef as ReactComponent };